import { createServerFn } from '@tanstack/react-start';
import { createClient } from '@supabase/supabase-js';
import { z } from 'zod';

/** Public alias lookup only; no contact details or privileged client. */
export const resolveDealerAlias = createServerFn({ method: 'GET' })
  .inputValidator((data: unknown) => z.object({ id: z.string().min(1).max(160) }).parse(data))
  .handler(async ({ data }) => {
    const url = process.env['SUPABASE_URL'];
    const key = process.env['SUPABASE_PUBLISHABLE_KEY'];
    if (!url || !key) throw new Error('Public dealer lookup unavailable');
    const db = createClient(url, key, {
      auth: { persistSession: false, autoRefreshToken: false, storage: undefined },
      global: { fetch: (input, init) => {
        const headers = new Headers(init?.headers);
        if (key.startsWith('sb_') && headers.get('Authorization') === `Bearer ${key}`) headers.delete('Authorization');
        headers.set('apikey', key);
        return fetch(input, { ...init, headers });
      } },
    });
    const { data: alias, error } = await db.rpc('get_dealer_alias_by_id_prefix', { _prefix: data.id });
    if (error) throw error;
    if (typeof alias === 'string' && alias) return alias;
    if (/^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(data.id)) {
      const { data: dealer, error: profileError } = await db.from('dealer_profiles')
        .select('subdomain_alias').eq('user_id', data.id).maybeSingle();
      if (profileError) throw profileError;
      return dealer?.subdomain_alias || null;
    }
    return null;
  });